<template>
    <div class="nav-new" v-if="newMode">
        <ul>
            <li>
                <router-link v-bind:active-class="'legitRipple1'" :to="{name: 'dashboard'}" :active-class="'active'" exact>
                    <div><i class="fa fa-th"></i></div>
                    Dashboard
                </router-link>
            </li>
            <li v-if="_can('readProjects')">
                <router-link v-bind:active-class="'legitRipple1'" :to="{name: 'project'}" :active-class="'active'">
                    <div><i class="fab fa-buffer"></i></div>
                    Projects
                </router-link>
            </li>
            <li v-if="_can('readProjects')">
                <router-link v-bind:active-class="'legitRipple1'" :to="{name: 'apartment'}" :active-class="'active'">
                    <div><i class="fa fa-home"></i></div>
                    Apartments
                </router-link>
            </li>
            <li v-if="_can('readSale')">
                <router-link v-bind:active-class="'legitRipple1'" :to="{name: 'sale'}" :active-class="'active'">
                    <div><i class="fa fa-chart-line"></i></div>
                    Sales
                </router-link>
            </li>
            <li v-if="_is('agencyAgent') || _is('agencyAdmin') || _is('superAdmin')">
                <router-link v-bind:active-class="'legitRipple1'" :to="{name: 'prospects'}" :active-class="'active'">
                    <div><i class="fa fa-user-friends"></i></div>
                    Prospects
                </router-link>
            </li>
            <li v-if="_is('agencyAdmin') || _is('superAdmin')">
                <router-link v-bind:active-class="'legitRipple1'" :to="{name: 'agency'}" :active-class="'active'">
                    <div><i class="fa fa-users-cog"></i></div>
                    <span>Agencies</span>
                </router-link>
            </li>
            <li v-if="_is('superAdmin')">
                <router-link v-bind:active-class="'legitRipple1'" :to="{name: 'configuration'}" :active-class="'active'">
                    <div><i class="fa fa-tools"></i></div>
                    <span>System Tools</span>
                </router-link>
            </li>
            <li v-if="_is('agencyAgent') || _is('agencyAdmin') || _is('superAdmin')">
                <router-link v-bind:active-class="'legitRipple1'" :to="{name: 'calculator'}" :active-class="'active'">
                    <div><i class="fa fa-calculator"></i></div>
                    <span>Calculator</span>
                </router-link>
            </li>
        </ul>
    </div>
    <!-- Main sidebar -->
    <div class="sidebar sidebar-main sidebar-default" v-else>
        <div class="sidebar-content">
            <!-- User menu -->
            <div class="sidebar-user-material" v-if="material">
                <div class="category-content">
                    <div class="sidebar-user-material-content">
                        <a href="#">
                            <div class="img img-circle img-thumbnail img-responsive" :style="{'background-image': 'url('+require('@/assets/images/saad-profile-logo-small.jpg')+')'}"></div>
                        </a>
                        <h6>{{ userName }}</h6>
                        <!-- span class="text-size-small">Santa Ana, CA</span -->
                        <div class="background-image"></div>
                    </div>

                    <div class="sidebar-user-material-menu">
                        <a href="#user-nav" data-toggle="collapse"><span>My account</span> <i class="caret"></i></a>
                    </div>
                </div>

                <div class="navigation-wrapper collapse" id="user-nav">
                    <ul class="navigation">
                        <!-- li><router-link :to="{name: 'user.profile'}"><i class="icon-user-plus"></i> <span>My profile</span></router-link></li -->
                        <!-- li><a href="#"><i class="icon-coins"></i> <span>My balance</span></a></li -->
                        <!-- li><a href="#"><i class="icon-comment-discussion"></i> <span><span class="badge bg-teal-400 pull-right">58</span> Messages</span></a></li -->
                        <!-- li class="divider"></li -->
                        <!-- li><router-link  :to="{name: 'user.settings'}"><i class="icon-cog5"></i> <span>Account settings</span></router-link></li -->
                        <li><a href="#" @click.prevent="logoutRedirect"><i class="icon-switch2"></i> <span>Logout</span></a></li>
                    </ul>
                </div>
            </div>
            <!-- /user menu -->

            <!-- Main navigation -->
            <div class="sidebar-category sidebar-category-visible">
                <div class="category-content no-padding">
                    <ul class="navigation navigation-main navigation-accordion">

                        <!-- Main -->
                        <li class="navigation-header"><span>Main</span> <i class="icon-menu" title="Main pages"></i></li>
                        <li><router-link v-bind:active-class="'legitRipple1'" :to="{name: 'dashboard'}"><i class="icon-home4"></i> <span>Dashboard</span></router-link></li>
                        <!-- /main -->

                        <!-- Forms -->
                        <li class="navigation-header"><span>Management</span> <i class="icon-menu" title="Management"></i></li>
                        <li v-if="_can('readProjects')">
                            <router-link v-bind:active-class="'legitRipple1'" :to="{name: 'project'}"><i class="icon-home2"></i> <span>Projects</span></router-link>
                        </li>
                        <li v-if="_can('readProjects')">
                            <router-link v-bind:active-class="'legitRipple1'" :to="{name: 'apartment'}"><i class="icon-home8"></i> <span>Apartments</span></router-link>
                        </li>
                        <li v-if="_can('readSale')">
                            <router-link v-bind:active-class="'legitRipple1'" :to="{name: 'sale'}"><i class="icon-home8"></i> <span>Sales</span></router-link>
                        </li>
                        <li v-if="_can('readSale')">
                            <router-link v-bind:active-class="'legitRipple1'" :to="{name: 'invoice'}"><i class="icon-coins"></i> <span>Invoices</span></router-link>
                        </li>

                        <li class="navigation-header"><span>System</span> <i class="icon-menu" title="System"></i></li>
                        <li v-if="_is('agencyAgent') || _is('agencyAdmin') || _is('superAdmin')">
                            <router-link v-bind:active-class="'legitRipple1'" :to="{name: 'prospects'}"><i class="icon-users"></i> <span>Prospects</span></router-link>
                        </li>
                        <!-- li v-if="_is('agencyAdmin') || _is('superAdmin')">
                            <router-link v-bind:active-class="'legitRipple1'" :to="{name: 'users'}"><i class="icon-users"></i> <span>Users</span></router-link>
                        </li -->
                        <li v-if="_is('agencyAdmin') || _is('superAdmin')">
                            <router-link v-bind:active-class="'legitRipple1'" :to="{name: 'agency'}"><i class="icon-home4"></i> <span>Agencies</span></router-link>
                        </li>
                        <li v-if="_is('superAdmin')">
                            <router-link v-bind:active-class="'legitRipple1'" :to="{name: 'configuration'}"><i class="icon-wrench2"></i> <span>System Tools</span></router-link>
                        </li>
                        <li v-if="_is('superAdmin')">
                            <router-link v-bind:active-class="'legitRipple1'" :to="{name: 'calculator'}"><i class="icon-calculator"></i> <span>Calculator</span></router-link>
                        </li>
                        <!-- /appearance -->

                        <!-- Page kits -->
                        <!-- li>
                            <a href="#"><i class="icon-people"></i> <span>Users</span></a>
                            <ul>
                                <li><router-link v-bind:active-class="'legitRipple1'" :to="{name: 'users'}">Manage users</router-link></li>
                                <li><router-link v-bind:active-class="'legitRipple1'" :to="{name: 'roles'}">Manage roles</router-link></li>
                            </ul>
                        </li -->
                        <!-- /page kits -->

                    </ul>
                </div>
            </div>
            <!-- /main navigation -->

        </div>
    </div>
    <!-- /main sidebar -->
</template>

<script>
import Vuex from 'vuex'

// import '@/assets/js/plugins/ui/ripple.min'

export default {
  name: 'MainSidebar',

  props: ['material', 'newMode'],

  data () {
    return {
    }
  },

  mounted () {
    /* document.body.className = 'layout-boxed'
              document.getElementById('navbar-container').className = 'navbar-boxed' */
    this.activateLinks()
  },

  methods: {
    ...Vuex.mapActions(['logout']),

    logoutRedirect () {
      // Force vuex reset with $router.go
      this.logout().then(() => this.$router.go({ name: 'login' }))
    },

    activateLinks () {
      let activeLink = document.getElementsByClassName('active')[0]
      if (activeLink) {
        let els = document.getElementsByClassName('active')
        for (let i = 0; i < els.len; i++) {
          if (els[i].classList && els[i].classList.contains('active')) {
            els[ i ].classList.remove('active')
          }
        }
        /* if (!activeLink.classList.contains('legitRipple1')) {
            activeLink.classList.add('legitRipple1')
          } */
        let linkContainer = activeLink.parentElement
        if (!linkContainer.classList.contains('active')) {
          // linkContainer.classList.add('active')
        }
        let subMenu = activeLink.parentElement.parentElement
        if (subMenu) {
          let parentMenu = subMenu.parentElement
          if (!parentMenu.classList.contains('active')) {
            parentMenu.classList.add('active')
            // parentMenu.childNodes[0].classList.add('legitRipple1')
            subMenu.style['display'] = 'block'
          }
        }
      }
    }
  },

  computed: {
    userImage: function () {
      return ''
    },
    ...Vuex.mapGetters(['isLoggedIn', 'userName', 'boxed', 'fullscreen', 'isSidebarFull'])
  },

  watch: {
    '$route': function (from, to) {
      // this.activateLinks()
    }
  },

  beforeRouteEnter (to, from, next) {
    this.activateLinks()
  }

}
</script>

<style>
    .navbar-brand {
        overflow: hidden;
    }
</style>
